import { useState } from "react";
import styles from "../AddQuestions.module.css";
import { TextComponent } from "../../../../../components";
import { GoChevronLeft, GoChevronRight } from "react-icons/go";

const Question = ({
  ques,
  setCurrentQues,
  setAllQuestions,
  index,
  setIsAdd,
  setID,
}) => {
  // const [isOpen, setIsOpen] = useState(false);
// let ID = index + 1;
  return (
    <div
      className={styles.innerContainer1}
      onClick={() => {
        // if (isAdd) {
        //   setIsAdd(false);
        // }
        setAllQuestions((prev) =>
          prev?.map((item, index) => {
            if (item.id === ques.id) {
              return { ...item, isOpen: !item.isOpen, id: index + 1};
            } else {
              return { ...item, isOpen: false, id: index + 1};
            }
          })
        );
        setCurrentQues(ques);
        setIsAdd(false);
      }}
    >
      <div className={styles.containerHeader1}>
        <TextComponent
          textClass={ques.isOpen ? styles.innertext2 : styles.innerText}
          text={`Question#${index + 1}`}
        />
        {ques.isOpen ? (
          <GoChevronLeft size={25} />
        ) : (
          <GoChevronRight size={25} />
        )}
      </div>
      {ques.isOpen ? (
        <TextComponent textClass={styles.innerText1} text={ques.question} />
      ) : null}
    </div>
  );
};

export default Question;
